import React from 'react';
import styled from 'styled-components';

const ProjectSummaryWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 80px 0 20px 0;
`;
const ProjectSummaryLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
  border-right: 1px solid #ccc;
  padding: 3px 10px 0 0;
  width: 50%;
  font-size: 0.9rem;
  letter-spacing: 0.2em;
  line-height: 1.4;
  justify-content: center;
`;
const ProjectSummaryRight = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3px 0 0 10px;
  width: 50%;
  font-size: 0.9rem;
  line-height: 1.4;
  justify-content: center;
`;

const ProjectSummary = ({ projectData }) => {
  return (
    <ProjectSummaryWrapper>
      <ProjectSummaryLeft>
        <span>{projectData.wie !== "" ? 'WIE' : ''}</span>
        <span>{projectData.wat !== "" ? 'WAT' : ''}</span>
        <span>{projectData.waar !== "" ? 'WAAR' : ''}</span>
        <span>{projectData.wanneer !== "" ? projectData.type === 'inOpbouw' ? 'STATUS' : 'WANNEER' : ''}</span>
      </ProjectSummaryLeft>
      <ProjectSummaryRight>
        <span>{projectData.wie}</span>
        <span>{projectData.wat}</span>
        <span>{projectData.waar}</span>
        <span>{projectData.wanneer}</span>
      </ProjectSummaryRight>
    </ProjectSummaryWrapper>
  );
};

export default ProjectSummary;



// WEBPACK FOOTER //
// ./src/componenten/ProjectSummary.js